import "./Home.scss";
import { observer } from "mobx-react-lite";
import CaseStatistics from "../../components/Cases/CaseStatistics";
import authStore from "../../stores/AuthStore";
import { Link } from "react-router-dom";
import { UserRoles } from "../../stores/AuthStore/types";
import AdminDashboard from "./AdminDashboard";
import LawyerDashboard from "./LawyerDashboard";
import UserDashboard from "./UserDashboard";
import useTranslation from "../../hooks/useTranslation";
import PendingJobs from "./PendingJobs";
import configStore, { Flags } from "../../stores/ConfigStore";
import { Alert } from "@mui/material";
import { isCordova } from "../../utils/constants";

const Home = observer(() => {
  const { t } = useTranslation();

  return (
    <div className="homeContainer container">
      {isCordova && t("mobile-announcement") !== "mobile-announcement" && (
        <Alert severity="info" className="mb">
          {t("mobile-announcement")}
        </Alert>
      )}
      {!isCordova && t("web-announcement") !== "web-announcement" && (
        <Alert severity="info" className="mb">
          {t("web-announcement")}
        </Alert>
      )}
      {authStore.userHasRole(UserRoles.USER) && <UserDashboard />}
      {authStore.userHasRole(UserRoles.LAWYER) && <LawyerDashboard />}
      {authStore.userHasRole(UserRoles.ADMIN) && (
        <>
          <h2 className={"mb pb"}>{t("admin-panel")}</h2>
          <AdminDashboard />
        </>
      )}
      {(authStore.userHasRole(UserRoles.ADMIN) ||
        authStore.userHasRole(UserRoles.AGENT)) && <PendingJobs />}
      <CaseStatistics />
      {!authStore.userHasRole(UserRoles.PREMIUM) &&
        authStore.userHasRole(UserRoles.LAWYER) &&
        configStore.getFlag(Flags.isPremiumEnabled) && (
          <div className="premiumBanner">
            <p>{t("premiumPageSubtitle")}</p>
            <footer>
              <Link to={"/premium"}>{t("subscribePremiumNow")}</Link>
            </footer>
          </div>
        )}
    </div>
  );
});

export default Home;
